import collectionApiClient, {
  OrderGraphData,
  OrderGraphPeriod,
} from '../../../api/collections';
import useKlydoQuery from '../../../hooks/useKlydoQuery';

const useAllCollectionsOrdersGraphQuery = (period?: OrderGraphPeriod) => {
  return useKlydoQuery<OrderGraphData>({
    queryKey: ['allCollectionsOrdersGraph', period],
    queryFn: () => collectionApiClient.getAllCollectionsOrdersGraph(period),
  });
};

export default useAllCollectionsOrdersGraphQuery;
